import { Palette } from '@common/theming/Palette';
import React from 'react';
import { AssetBlockProps } from '../../pages/AssetApp';
import { CapitalStackColor } from '../../types';
import { TextBlock } from '../TextBlock';
import ProfileAssetHeading from './ProfileAssetHeading';

const CapitalStack: React.FC<AssetBlockProps> = ({ asset }) => {
  const Colors: Record<CapitalStackColor, string> = {
    BLUE: '#308EFF',
    GREEN: '#34CA4D',
    ORNAGE: '#FF6B00',
    PURPLE: '8000FF',
    RED: '#D92626',
    YELLOW: '#F7E332',
  };

  return (
    <div>
      <ProfileAssetHeading heading={asset.capitalStack?.heading} />
      <div style={{ marginTop: 24 }}>
        <div style={{ display: 'flex', flex: 1 }}>
          {asset.capitalStack?.parts.map((part, i) => {
            const last = asset.capitalStack ? asset.capitalStack.parts.length - 1 : 0;

            return (
              <div
                key={`capitalStackGraph-${i}`}
                style={{
                  backgroundColor: Colors[part.color],
                  border: '1px solid #000000',
                  borderBottomLeftRadius: i === 0 ? 15 : 0,
                  borderBottomRightRadius: i === last ? 15 : 0,
                  borderTopLeftRadius: i === 0 ? 15 : 0,
                  borderTopRightRadius: i === last ? 15 : 0,
                  height: 34,
                  width: `${part.percentage}%`,
                }}></div>
            );
          })}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
          <TextBlock size={12} style={{ marginLeft: 10 }} weight={'bold'}>
            {asset.capitalStack?.total}
          </TextBlock>
          <TextBlock size={12} style={{ color: Palette.WHITE_80, marginRight: 10 }}>
            Total Capitalization
          </TextBlock>
        </div>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', marginLeft: 10, marginTop: 24 }}>
        {asset.capitalStack?.parts.map((part, i) => {
          return (
            <div key={`capitalStackLegend-${i}`} style={{ display: 'flex', paddingBottom: 16, width: '50%' }}>
              <div
                style={{
                  backgroundColor: Colors[part.color],
                  borderRadius: 15,
                  height: 15,
                  width: 15,
                }}></div>
              <div>
                <TextBlock weight={'bold'} style={{ marginLeft: 10 }}>
                  {part.debtType}
                </TextBlock>
                <TextBlock color={Palette.WHITE_80} style={{ marginLeft: 10, marginTop: 4 }}>
                  {part.debtAmount}
                </TextBlock>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CapitalStack;
